import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminAllProducts from "@/pages/admin/AdminAllProducts";

export const Route = createFileRoute("/admin/all-products")({
  component: () => (
    <ProtectedRoute>
      <AdminAllProducts />
    </ProtectedRoute>
  ),
});
